class AdawatSubcatCarousel extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.adawat-subcat-carousel__viewport');
    this.track = this.querySelector('[data-subcat-track]');
    this.items = Array.from(this.querySelectorAll('[data-subcat-item]'));
    this.prevBtn = this.querySelector('[data-subcat-prev]');
    this.nextBtn = this.querySelector('[data-subcat-next]');

    if (!this.viewport || !this.track || this.items.length === 0) return;

    this.dragging = false;
    this.dragMoved = false;
    this.startX = 0;
    this.startScroll = 0;
    this.pointerId = null;

    this.prevBtn?.addEventListener('click', () => this.scrollByDir(-1));
    this.nextBtn?.addEventListener('click', () => this.scrollByDir(1));
    this.viewport.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    window.addEventListener('resize', () => this.updateButtons());

    this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event));
    this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event));
    this.viewport.addEventListener('pointerup', (event) => this.onPointerUp(event));
    this.viewport.addEventListener('pointercancel', (event) => this.onPointerUp(event));
    this.viewport.addEventListener('pointerleave', (event) => {
      if (this.dragging) this.onPointerUp(event);
    });

    this.track.addEventListener(
      'click',
      (event) => {
        if (this.dragMoved) {
          event.preventDefault();
          event.stopPropagation();
          this.dragMoved = false;
        }
      },
      true
    );

    this.track.style.transform = '';
    this.updateButtons();
  }

  isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  getStep() {
    const item = this.items[0];
    if (!item) return 0;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 20;
    return item.offsetWidth + gap;
  }

  getMaxScroll() {
    return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
  }

  scrollByDir(direction) {
    const step = this.getStep();
    if (!step) return;
    const isRtl = document.documentElement.dir === 'rtl';
    const delta = (isRtl ? -direction : direction) * step;
    this.viewport.scrollBy({ left: delta, behavior: 'smooth' });
  }

  updateButtons() {
    if (this.isMobile()) {
      if (this.prevBtn) this.prevBtn.hidden = true;
      if (this.nextBtn) this.nextBtn.hidden = true;
      return;
    }

    const max = this.getMaxScroll();
    const left = Math.abs(this.viewport.scrollLeft);
    const edge = 2;

    if (this.prevBtn) {
      this.prevBtn.hidden = false;
      this.prevBtn.disabled = left <= edge;
    }
    if (this.nextBtn) {
      this.nextBtn.hidden = false;
      this.nextBtn.disabled = left >= max - edge;
    }
  }

  onPointerDown(event) {
    // Touch/pen: native overflow scroll. Mouse uses custom drag.
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    if (event.target.closest('button, .adawat-subcat-carousel__arrow')) return;

    this.dragging = true;
    this.dragMoved = false;
    this.startX = event.clientX;
    this.startScroll = this.viewport.scrollLeft;
    this.pointerId = event.pointerId;
  }

  onPointerMove(event) {
    if (!this.dragging || event.pointerId !== this.pointerId) return;
    const delta = event.clientX - this.startX;
    if (Math.abs(delta) <= 6) return;

    if (!this.dragMoved) {
      this.dragMoved = true;
      this.viewport.classList.add('is-dragging');
      this.viewport.setPointerCapture?.(event.pointerId);
    }

    this.viewport.scrollLeft = this.startScroll - delta;
    event.preventDefault();
  }

  onPointerUp(event) {
    if (!this.dragging || (this.pointerId != null && event.pointerId !== this.pointerId)) return;

    const didDrag = this.dragMoved;
    this.dragging = false;
    this.pointerId = null;
    this.viewport.classList.remove('is-dragging');

    try {
      this.viewport.releasePointerCapture?.(event.pointerId);
    } catch (error) {
      /* ignore */
    }

    if (!didDrag) {
      this.dragMoved = false;
      this.updateButtons();
      return;
    }

    this.updateButtons();
    window.setTimeout(() => {
      this.dragMoved = false;
    }, 0);
  }
}

if (!customElements.get('adawat-subcat-carousel')) {
  customElements.define('adawat-subcat-carousel', AdawatSubcatCarousel);
}
